import React from 'react';
import { IconProps } from './types';

export const WarningIcon = ({ className, title }: IconProps) => {
  return (
    <svg
      id="Laag_2"
      data-name="Laag 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      className={className}
    >
      <title>{title}</title>
      <path d="M15,1,1,29H29Zm0,4.47L25.77,27H4.24Z" />
      <rect x="13.59" y="13.14" width="3.1" height="7.56" />
      <path d="M15.13,21.71a1.7,1.7,0,1,0,1.69,1.69A1.68,1.68,0,0,0,15.13,21.71Z" />
    </svg>
  );
};
